<script setup></script>

<template>
  <div class="tw-py-2l tw-h-10 tw-w-full tw-px-4 tw-text-center">
    <a class="tw-h-ful tw-ml-auto tw-inline-block" href="https://www.nabooki.com/booking-system/" target="_blank">
      <span class="tw-text-medium tw-text-[8px] tw-text-primary-navy">Powered by</span>
      <img :src="asset('/assets/img/nabooki_logoH110.png')" alt="Powered By Nabooki" class="tw-m-auto tw-h-5" />
    </a>
  </div>
</template>
